import { createSlice } from "@reduxjs/toolkit";
// utils
import axios from "../../utils/axios";
//
import { dispatch } from "../store";

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  usercommissions: { count: 0, data: [], num_pages: 1, page: 1, page_size: "5" },
  operators: { count: 0, data: [], num_pages: 1, page: 1, page_size: "5" },
};

const slice = createSlice({
  name: "usercommission",
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET USER COMMISSIONS
    getUserCommissionSuccess(state, action) {
      state.isLoading = false;
      state.usercommissions = action.payload;
    },

    // GET OPERATORS
    getOperatorSuccess(state, action) {
      state.isLoading = false;
      state.operators = action.payload;
    },

    // ADD USER COMMISSION
    addUserCommissionSuccess(state, action) {
      const usercommission = action.payload;
      state.usercommissions.data.push(usercommission);
      state.usercommissions.count += 1;
    },

    // UPDATE USER COMMISSIONS
    updateUserCommissionSuccess(state, action) {
      const usercommission = action.payload;
      if (state.usercommissions && state.usercommissions.data) {
        const usercommissionIndex = state.usercommissions?.data?.findIndex(
          (obj) => obj.id === usercommission.id
        );
        if (usercommissionIndex !== -1) {
          state.isLoading = false;
          state.usercommissions.data[usercommissionIndex] = usercommission;
        }
      } else {
        state.usercommissions = { data: [] };
        state.usercommissions.data.push(usercommission);
      }
    },

    // DELETE USER COMMISSION
    deleteUserCommissionSuccess(state, action) {
      const deletedUserCommissionId = action.payload;
      state.usercommissions.data = state.usercommissions.data.filter(
        (usercommission) => usercommission.id !== deletedUserCommissionId
      );
      state.isLoading = false;
    },

    // DELETE USER COMMISSIONS
    deleteUserCommissionsSuccess(state, action) {
      const deletedUserCommissionIds = action.payload;
      state.usercommissions.data = state.usercommissions.data.filter(
        (usercommission) => !deletedUserCommissionIds.includes(usercommission.id)
      );
      state.isLoading = false;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  addUserCommissionSuccess,
  updateUserCommissionSuccess,
  deleteUserCommissionSuccess,
  deleteUserCommissionsSuccess,
} = slice.actions;

// ----------------------------------------------------------------------

export function getUserCommissions(page = 1, rowsPerPage = 5, filterName) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/v1/dashboard-supervisor/user-commissions?page=${page}&page_size=${rowsPerPage}&search=${filterName}`
      );
      dispatch(slice.actions.getUserCommissionSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getOperators(page = 1, rowsPerPage = 5) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(
        `/api/v1/dashboard-supervisor/operators?page=${page}&page_size=${rowsPerPage}`
      );
      dispatch(slice.actions.getOperatorSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export async function getUserCommission(keyId) {
  const response = await axios.get(
    `/api/v1/dashboard-supervisor/user-commission-id?keyId=${keyId}`
  );
  return response.data;
}

export async function addUserCommission(data) {
  const response = await axios.post(`/api/v1/dashboard-supervisor/user-commissions`, data);
  return response.data;
}

export async function updateUserCommission(data) {
  const response = await axios.put(`/api/v1/dashboard-supervisor/user-commissions`, data);
  return response.data;
}

export async function deleteUserCommission(keyId) {
  const response = await axios.delete(`/api/v1/dashboard-supervisor/user-commissions`, {
    data: { keyId },
  });
  return response.data;
}

export async function deleteUserCommissions(keyIds) {
  const response = await axios.delete(`/api/v1/dashboard-supervisor/user-commission-id`, {
    data: { keyIds },
  });
  return response.data;
}
